import { PropsWithChildren } from "react";
import { DetailHeader } from "./DetailHeader";
import { Property } from "csstype";

const DetailLayout = (
  props: PropsWithChildren<any> & { maxWidth?: Property.MaxWidth }
) => {
  return (
    <main
      style={{
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <DetailHeader />
      <div
        style={{
          flex: 1,
          flexGrow: 1,
          margin: "auto",
          maxWidth: props.maxWidth !== undefined ? props.maxWidth : "70%",
          padding: "20px 10px",
          paddingTop: "100px",
          minHeight: "calc(100vh - 120px)",
        }}
      >
        {props.children}
      </div>
    </main>
  );
};

export default DetailLayout;
